import _ from "lodash";

export const AutoExpand = {
    twoWay: true,

    bind: function (el, binding, vnode) {
        el.setAttribute('autoexpand', true);

        const resize = function () {
            let offset = el.offsetHeight - el.clientHeight;

            el.style.height = 'auto';
            el.style.height = Math.max(el.scrollHeight + offset, 48) + 'px';
        };

        el.oncut = el.onchange = el.oninput = el.onpaste = el.ondrop = resize;

        el.onkeydown = _.throttle(resize);

        setTimeout(() => {
            el.dispatchEvent(new InputEvent('change'));
        }, 10);
    }
};
